import React from 'react';
import classNames from 'classnames';
import { Icon } from 'ui';

const OwnersList = ({ id, heading, owners, children, collapsed }) => {
  const ownerListItem = React.Children.only(children);
  return (
    <>
      <h3 className="Accordion-headingWrapper">
        <a
          href={`#${id}`}
          data-toggle="collapse"
          className={classNames(
            'd-f jc-sb u-resetBtn w-fill Accordion-heading',
            collapsed && 'collapsed',
          )}
        >
          {heading}
          <Icon name="expand" className="Accordion-icon" />
        </a>
      </h3>
      <div id={id} className={classNames('collapse', !collapsed && 'in')}>
        {owners.map(owner =>
          React.cloneElement(ownerListItem, {
            key: owner.unique_identifier,
            owner,
            ownershipType: heading,
          }),
        )}
      </div>
    </>
  );
};

export default OwnersList;
